import { createSlice } from "@reduxjs/toolkit";
import { LoginState } from "./auth.interfaces";
import { loginUser } from "./auth.actions";

const initialState: LoginState = {
  isLoginLoading: false,
  isLoginSuccess: false,
  isLoginError: false,
  loginError: "",
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loginUser.pending, (state) => {
      state.isLoginLoading = true;
      state.isLoginSuccess = false;
      state.isLoginError = false;
      state.loginError = "";
    });

    builder.addCase(loginUser.fulfilled, (state, action) => {
      state.isLoginLoading = false;
      state.isLoginSuccess = true;
      state.isLoginError = false;

      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("user", JSON.stringify(action.payload.user));
    });

    builder.addCase(loginUser.rejected, (state, action) => {
      state.isLoginLoading = false;
      state.isLoginSuccess = false;
      state.isLoginError = true;
      state.loginError = `${action.error.message}`;
    });
  },
});

export default loginSlice.reducer;
